import { render, staticRenderFns } from "./ApprovalTemplate.vue?vue&type=template&id=2fc3035e&scoped=true"
import script from "./ApprovalTemplate.vue?vue&type=script&lang=js"
export * from "./ApprovalTemplate.vue?vue&type=script&lang=js"
import style0 from "./ApprovalTemplate.vue?vue&type=style&index=0&id=2fc3035e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3035e",
  null
  
)

export default component.exports